import apiClient from '../utils/apiClient';
import { InsertSet, Product } from 'shared/models';
import productService from './productService';

const API_URL = '/api/insert-sets';


const insertSetService = {
  // Get all insert sets with pagination
  getInsertSetsByPage: async (page = 1, limit = 20, filter = {}) => {
    const params = {
      page,
      limit,
      ...filter
    };
    
    const response = await apiClient.get(API_URL, { params });
    
    // Return paginated response with InsertSet instances
    return {
      insertSets: (response.data.insertSets || []).map(data => new InsertSet(data)),
      currentPage: response.data.currentPage || page,
      totalPages: response.data.totalPages || 1,
      totalInsertSets: response.data.totalInsertSets || 0
    };
  },
  
  // Get insert set by ID
  getInsertSetById: async (insertSetId) => {
    const response = await apiClient.get(`${API_URL}/${insertSetId}`);
    
    // Convert to InsertSet instance
    return new InsertSet(response.data.insertSet);
  },
  
  // Get all insert sets by product with pagination
  getInsertSetsByProductByPage: async (product, page = 1, limit = 50) => {
    const params = {
      page,
      limit
    };
    
    const response = await apiClient.get(`${API_URL}/product/${product.id}`, { params });
    
    // Return paginated response with InsertSet instances
    return {
      insertSets: (response.data.insertSets || []).map(data => new InsertSet(data)),
      currentPage: response.data.currentPage || page,
      totalPages: response.data.totalPages || 1,
      totalInsertSets: response.data.totalInsertSets || 0
    };
  },
  
  // Get only insert sets by product that the user has cards for with pagination
  getUserCollectionInsertSetsByProductByPage: async (userId, product, page = 1, limit = 50) => {
    const params = {
      page,
      limit,
      userId
    };
    
    const response = await apiClient.get(`${API_URL}/user/product/${product.id}`, { 
      params
    });
    
    // Return paginated response with InsertSet instances
    return {
      insertSets: (response.data.insertSets || []).map(data => new InsertSet(data)),
      currentPage: response.data.currentPage || page,
      totalPages: response.data.totalPages || 1,
      totalInsertSets: response.data.totalInsertSets || 0
    };
  },
  
  // Only public methods here - admin methods moved to insertSetAdminService
  
  // Get the product associated with an insert set
  getProductForInsertSet: async (insertSet) => {
    if (!insertSet || !insertSet.productId) {
      throw new Error('Invalid insert set or missing product ID');
    }
    
    try {
      // Use productService to get the product by ID
      return await productService.getProductById(insertSet.productId);
    } catch (error) {
      console.error('Error fetching product for insert set:', error);
      throw error;
    }
  }
};

export default insertSetService;